import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_USERS_USAGE_HISTORY = 'FETCH_ANALYTIC_DOMAIN_USERS_USAGE_HISTORY';
export const fetchAnalyticDomainUsersUsageHistoryAction = createAction(FETCH_ANALYTIC_DOMAIN_USERS_USAGE_HISTORY);